import './index.scss';
import './Edit.scss';
import './Modals.scss';